module.exports = __webpack_public_path__ + "static/media/logHistory.ca34680a.svg";